export default "__VITE_ASSET__9550c659__"